// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shadow-filter-card-selected {
  box-shadow:
    0 4px 5px 0 var(--app-filter-selected-shadow-14),
    0 1px 10px 0 var(--app-filter-selected-shadow-12),
    0 2px 4px -1px var(--app-filter-selected-shadow-30);
  -webkit-box-shadow:
    0 4px 5px 0 var(--app-filter-selected-shadow-14),
    0 1px 10px 0 var(--app-filter-selected-shadow-12),
    0 2px 4px -1px var(--app-filter-selected-shadow-30);
}

.filter-card-line {
  margin: 5px 0px 0px 0px;
  padding: 0px 8px;
  display: flex;
  justify-content: safe center;
  overflow-x: auto;
  scroll-behavior: smooth;
}

.card {
  margin: 5px !important;
  padding: 0px !important;
  border-radius: 7px !important;
  height: 40px;
  min-width: 140px;
  max-width: 140px;
  cursor: pointer;
  border: none !important;
}

.filter-card {
  margin: 0px;
  padding: 5px;
  border-radius: 5px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.filter-card-icon {
  margin-left: auto;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 32px;
  min-width: 32px;
  height: 32px;
  width: 32px;
  border-radius: 25px;
  color: var(--app-white);
}

.filter-card-detail {
  padding: 3px;
  flex: 1;
  min-width: 0;
  font-size: var(--app-font-size-14px);
  line-height: var(--app-line-height-filter-card);
  letter-spacing: var(--app-letter-spacing-filter-card);
}

.filter-card-label {
  margin: 0px;
  max-width: 130px;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
}

.filter-card-label p {
  white-space: nowrap;
  display: inline-block;
  margin: 0;
  padding: 0;
}

/* Quando o texto é maior, alinha à esquerda e adiciona animação */
.filter-card-label.animate {
  justify-content: flex-start;
}

.filter-card-label.animate p {
  animation-name: slide-reveal;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
}

@keyframes slide-reveal {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(var(--slide-distance));
  }
  75% {
    transform: translateX(var(--slide-distance));
  }
  75.1% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(0);
  }
}

.filter-card-length {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--app-font-size-18px);
  font-weight: var(--app-font-weight-bold);
}

.filter-card-length h1 {
  font-weight: var(--app-font-weight-bold);
  margin: 0px;
}

/* Animação de alerta */
.alert-active {
  animation: alert-pulse 1.4s infinite;
}

.alert-active .filter-card-icon {
  animation: alert-icon-pulse 1.4s infinite;
}

@keyframes alert-pulse {
  0%,
  100% {
    background-color: var(--app-surface);
    color: var(--app-filter-text);
    border-top-color: var(--app-filter-color);
    box-shadow:
      var(--app-ink-alpha-100) 0px 4px 6px -1px,
      var(--app-ink-alpha-60) 0px 2px 4px -1px;
    -webkit-box-shadow:
      var(--app-ink-alpha-100) 0px 4px 6px -1px,
      var(--app-ink-alpha-60) 0px 2px 4px -1px;
  }
  50% {
    background-color: var(--app-filter-alert-bg);
    color: var(--app-solicitacao-red);
    border-top-color: var(--app-solicitacao-red);
    box-shadow:
      var(--app-filter-alert-shadow-10) 0px 4px 6px -1px,
      var(--app-filter-alert-shadow-06) 0px 2px 4px -1px;
    -webkit-box-shadow:
      var(--app-filter-alert-shadow-10) 0px 4px 6px -1px,
      var(--app-filter-alert-shadow-06) 0px 2px 4px -1px;
  }
}

@keyframes alert-icon-pulse {
  0%,
  100% {
    background-color: var(--app-filter-color);
  }
  50% {
    background-color: var(--app-solicitacao-red);
  }
}

.filter-card { color: var(--app-filter-text); border-top: 1.5px solid var(--app-filter-color); background-color: var(--app-surface); }
.filter-card-icon { background-color: var(--app-filter-color); }
.filter-card-icon .mdi { font-size: var(--app-font-size-20px); }
.filter-card.is-selected { color: var(--app-filter-selected); border-top-color: var(--app-filter-selected); background-color: var(--app-filter-selected-bg); }
.is-selected .filter-card-icon { background-color: var(--app-filter-selected); }
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/filter-card-line/filter-card-line.component.css"],"names":[],"mappings":"AAAA;EACE;;;uDAGqD;EACrD;;;uDAGqD;AACvD;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,YAAY;EACZ,oCAAoC;EACpC,+CAA+C;EAC/C,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA,kEAAkE;AAClE;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,sCAAsC;EACtC,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;;IAEE,oCAAoC;IACpC,6BAA6B;IAC7B,yCAAyC;IACzC;;8CAE0C;IAC1C;;8CAE0C;EAC5C;EACA;IACE,4CAA4C;IAC5C,iCAAiC;IACjC,4CAA4C;IAC5C;;wDAEoD;IACpD;;wDAEoD;EACtD;AACF;;AAEA;EACE;;IAEE,yCAAyC;EAC3C;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA,eAAe,6BAA6B,EAAE,+CAA+C,EAAE,oCAAoC,EAAE;AACrI,oBAAoB,yCAAyC,EAAE;AAC/D,yBAAyB,oCAAoC,EAAE;AAC/D,2BAA2B,iCAAiC,EAAE,4CAA4C,EAAE,+CAA+C,EAAE;AAC7J,iCAAiC,4CAA4C,EAAE","sourcesContent":[".shadow-filter-card-selected {\n  box-shadow:\n    0 4px 5px 0 var(--app-filter-selected-shadow-14),\n    0 1px 10px 0 var(--app-filter-selected-shadow-12),\n    0 2px 4px -1px var(--app-filter-selected-shadow-30);\n  -webkit-box-shadow:\n    0 4px 5px 0 var(--app-filter-selected-shadow-14),\n    0 1px 10px 0 var(--app-filter-selected-shadow-12),\n    0 2px 4px -1px var(--app-filter-selected-shadow-30);\n}\n\n.filter-card-line {\n  margin: 5px 0px 0px 0px;\n  padding: 0px 8px;\n  display: flex;\n  justify-content: safe center;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n}\n\n.card {\n  margin: 5px !important;\n  padding: 0px !important;\n  border-radius: 7px !important;\n  height: 40px;\n  min-width: 140px;\n  max-width: 140px;\n  cursor: pointer;\n  border: none !important;\n}\n\n.filter-card {\n  margin: 0px;\n  padding: 5px;\n  border-radius: 5px;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.filter-card-icon {\n  margin-left: auto;\n  padding: 0px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 32px;\n  min-width: 32px;\n  height: 32px;\n  width: 32px;\n  border-radius: 25px;\n  color: var(--app-white);\n}\n\n.filter-card-detail {\n  padding: 3px;\n  flex: 1;\n  min-width: 0;\n  font-size: var(--app-font-size-14px);\n  line-height: var(--app-line-height-filter-card);\n  letter-spacing: var(--app-letter-spacing-filter-card);\n}\n\n.filter-card-label {\n  margin: 0px;\n  max-width: 130px;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  justify-content: center;\n}\n\n.filter-card-label p {\n  white-space: nowrap;\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n}\n\n/* Quando o texto é maior, alinha à esquerda e adiciona animação */\n.filter-card-label.animate {\n  justify-content: flex-start;\n}\n\n.filter-card-label.animate p {\n  animation-name: slide-reveal;\n  animation-timing-function: ease-in-out;\n  animation-iteration-count: infinite;\n  animation-fill-mode: both;\n}\n\n@keyframes slide-reveal {\n  0% {\n    transform: translateX(0);\n  }\n  25% {\n    transform: translateX(0);\n  }\n  50% {\n    transform: translateX(var(--slide-distance));\n  }\n  75% {\n    transform: translateX(var(--slide-distance));\n  }\n  75.1% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n\n.filter-card-length {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--app-font-size-18px);\n  font-weight: var(--app-font-weight-bold);\n}\n\n.filter-card-length h1 {\n  font-weight: var(--app-font-weight-bold);\n  margin: 0px;\n}\n\n/* Animação de alerta */\n.alert-active {\n  animation: alert-pulse 1.4s infinite;\n}\n\n.alert-active .filter-card-icon {\n  animation: alert-icon-pulse 1.4s infinite;\n}\n\n@keyframes alert-pulse {\n  0%,\n  100% {\n    background-color: var(--app-surface);\n    color: var(--app-filter-text);\n    border-top-color: var(--app-filter-color);\n    box-shadow:\n      var(--app-ink-alpha-100) 0px 4px 6px -1px,\n      var(--app-ink-alpha-60) 0px 2px 4px -1px;\n    -webkit-box-shadow:\n      var(--app-ink-alpha-100) 0px 4px 6px -1px,\n      var(--app-ink-alpha-60) 0px 2px 4px -1px;\n  }\n  50% {\n    background-color: var(--app-filter-alert-bg);\n    color: var(--app-solicitacao-red);\n    border-top-color: var(--app-solicitacao-red);\n    box-shadow:\n      var(--app-filter-alert-shadow-10) 0px 4px 6px -1px,\n      var(--app-filter-alert-shadow-06) 0px 2px 4px -1px;\n    -webkit-box-shadow:\n      var(--app-filter-alert-shadow-10) 0px 4px 6px -1px,\n      var(--app-filter-alert-shadow-06) 0px 2px 4px -1px;\n  }\n}\n\n@keyframes alert-icon-pulse {\n  0%,\n  100% {\n    background-color: var(--app-filter-color);\n  }\n  50% {\n    background-color: var(--app-solicitacao-red);\n  }\n}\n\n.filter-card { color: var(--app-filter-text); border-top: 1.5px solid var(--app-filter-color); background-color: var(--app-surface); }\n.filter-card-icon { background-color: var(--app-filter-color); }\n.filter-card-icon .mdi { font-size: var(--app-font-size-20px); }\n.filter-card.is-selected { color: var(--app-filter-selected); border-top-color: var(--app-filter-selected); background-color: var(--app-filter-selected-bg); }\n.is-selected .filter-card-icon { background-color: var(--app-filter-selected); }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
